module.exports = __webpack_public_path__ + "static/fox@2x-5b6b15467f0836926e05f788ada6f088.png";